import styled from 'styled-components';

const DescriptionContainer = styled.div`
  flex: 1 0 auto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 14px;
  color: #242424;
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export default DescriptionContainer;
